// @flow
import React from 'react';

type Props = {
  handleNumPaxChange: Function,
  handleNumDaxChange: Function,
  disableInput: boolean,
  isCohortCreated: boolean,
  fillOptions: Function,
}

export default function NewCohortParams(props: Props) {
  if (props.isCohortCreated) {
    return (<div />);
  }
  return (
    <div className="field is-horizontal">
      <div className="field-body">
        <div className="field">
          <div className="label" htmlFor="num-passengers">Passengers Required</div>
          <div className="select">
            <select
              name="num-passengers"
              onChange={props.handleNumPaxChange}
              disabled={props.disableInput}
            >
              {props.fillOptions('pax')}
            </select>
          </div>
        </div>
        <div className="field">
          <div className="label" htmlFor="num-drivers">Drivers Required</div>
          <div className="select">
            <select
              name="num-drivers"
              onChange={props.handleNumDaxChange}
              disabled={props.disableInput}
            >
              {props.fillOptions('dax')}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}




/** WEBPACK FOOTER **
 ** ./src/js/views/autosim/simulation/components/NewCohortParams.jsx
 **/